import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core'

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'
import { GbPresenterToolsElevationComponent } from '../gb-presenter-tools-elevation/gb-presenter-tools-elevation.component'

@Component({
  selector: 'gb-presenter-tools-layout',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    GbPresenterToolsElevationComponent,
  ],
  templateUrl: './gb-presenter-tools-layout.component.html',
  styleUrl: './gb-presenter-tools-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPresenterToolsLayoutComponent {
  @Input({ required: true }) toolsFormGroup!: FormGroup

  @Output() alignLeft = new EventEmitter<void>()
  @Output() alignRight = new EventEmitter<void>()
  @Output() alignTop = new EventEmitter<void>()
  @Output() alignBottom = new EventEmitter<void>()
  @Output() alignHorizontalCenter = new EventEmitter<void>()
  @Output() alignVerticalCenter = new EventEmitter<void>()

  @Output() bringToFront = new EventEmitter<void>()
  @Output() bringForward = new EventEmitter<void>()
  @Output() sendBackward = new EventEmitter<void>()
  @Output() sendToBack = new EventEmitter<void>()

  get widthControl(): FormControl {
    return this.toolsFormGroup.get('width') as FormControl
  }

  get heightControl(): FormControl {
    return this.toolsFormGroup.get('height') as FormControl
  }

  onAlignLeft(): void {
    this.alignLeft.emit()
  }

  onAlignRight(): void {
    this.alignRight.emit()
  }

  onAlignTop(): void {
    this.alignTop.emit()
  }

  onAlignBottom(): void {
    this.alignBottom.emit()
  }

  onAlignHorizontalCenter(): void {
    this.alignHorizontalCenter.emit()
  }

  onAlignVerticalCenter(): void {
    this.alignVerticalCenter.emit()
  }

  onBringToFront(): void {
    this.bringToFront.emit()
  }

  onBringForward(): void {
    this.bringForward.emit()
  }

  onSendBackward(): void {
    this.sendBackward.emit()
  }

  onSendToBack(): void {
    this.sendToBack.emit()
  }
}
